import { createFileRoute } from '@tanstack/react-router'
import { AuthLayout, SignInCard } from '@/components/auth-card'
export const Route = createFileRoute('/sign-in')({ component: () => <AuthLayout showFooter={false}><SignInCard /></AuthLayout> })
